import type { DtbItem } from '@ocode/domain';
import type { LocalBookItem, LocalSectionItem } from './types';

/**
 * 서버에서 불러온 DtbItem 배열을 섹션단위로 그룹화합니다.
 */
export function convertDtbItemToLocalItems(
  dtbItems: DtbItem[],
): Array<LocalSectionItem | LocalBookItem> {
  const allItems = [] as Array<LocalSectionItem | LocalBookItem>;
  let lastSection: LocalSectionItem | undefined = undefined;
  for (let i = 0; i < dtbItems.length; i++) {
    const item = dtbItems[i];
    if (item.itemType === 'SECTN') {
      const section: LocalSectionItem = {
        type: 'SECTN',
        title: item.title,
        sectionSn: item.itemId,
        books: [],
      };
      allItems.push(section);
      lastSection = section;
    } else if (item.itemType === 'BOOK') {
      const book: LocalBookItem = {
        type: 'BOOK',
        title: item.title,
        bookId: item.itemId,
        book: item.book!,
      };
      if (lastSection) {
        lastSection.books.push(book);
      } else {
        allItems.push(book);
      }
    }
  }
  return allItems;
}
